import type { Provider, ProviderIos } from "./ports";

class Service {
  private readonly provider: Provider;

  constructor(provider: Provider) {
    this.provider = provider;
  }

  register(params: ProviderIos.Register.In) {
    return this.provider.register(params);
  }

  login(params: ProviderIos.Login.In) {
    return this.provider.login(params);
  }

  logout() {
    return this.provider.logout();
  }

  changePassword(params: ProviderIos.ChangePassword.In) {
    return this.provider.changePassword(params);
  }

  resetPassword(params: ProviderIos.ResetPassword.In) {
    return this.provider.resetPassword(params);
  }

  getMe() {
    return this.provider.getMe();
  }
}

export { Service };
